import { Button } from "@component/button";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@component/dialog";
import { InfoIcon } from "lucide-react";

interface SkipInterviewDialogProps {
    isOpen: boolean;
    isLoading?: boolean;
    onClose: () => void;
    onReturnToInterview: () => void;
    onProceedToSkip: () => void;
}

export default function SkipInterviewDialog({
    isOpen,
    isLoading = false,
    onClose,
    onReturnToInterview,
    onProceedToSkip,
}: SkipInterviewDialogProps) {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md p-0 gap-0">
                {/* Header with icon and title */}
                <DialogHeader className="px-4 pt-4 flex flex-row items-center justify-between space-y-0 mb-4">
                    <div className="flex items-center gap-2">
                        <div
                            className="w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-900/20 flex items-center justify-center"
                            style={{ backgroundColor: "transparent" }}
                        >
                            <InfoIcon className="h-5 w-5 text-blue-600 dark:text-blue-400" />
                        </div>
                        <DialogTitle className="text-lg font-semibold text-gray-900 dark:text-white">
                            Save Application as Draft
                        </DialogTitle>
                    </div>
                </DialogHeader>

                {/* Body content */}
                <div className="px-6 pb-6">
                    <div className="text-sm text-gray-600 dark:text-gray-300 space-y-4 mb-6">
                        <p>
                            Completing your AI interview is required for your application to move forward.
                        </p>
                        <p>
                            If you exit now, your application will be saved as <b>Draft</b> until you return to finish the interview.
                        </p>
                    </div>

                    {/* Action buttons */}
                    <div className="flex gap-3">
                        <Button
                            variant="outline"
                            onClick={onProceedToSkip}
                            disabled={isLoading}
                            className="flex-1 bg-transparent border-gray-300 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
                        >
                            {isLoading ? "Processing..." : "Save as Draft"}
                        </Button>
                        <Button
                            onClick={onReturnToInterview}
                            disabled={isLoading}
                            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white"
                        >
                            Continue Interview
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
